import React, { useState } from 'react'

import { Button } from 'component-library-next'

import { DeleteIcon } from '@app/assets/icons/DeleteIcon'
import Input from '@app/common/Components/Inputs/Input'
import { UploadLetterDropzone } from '@app/modules/Messages/Components/UploadLetterDropzone'

import { UploadDropzone } from '../UploadDropzone'

import './style.scss'

export type DocumentUploadPopupLawyerProps = {
  file: File
  onClose: () => void
  hasLetter?: boolean
  onSubmit: (formData: FormData) => void
  setFile: (file: File[]) => void
  onRemoveFile: () => void
}

export const DocumentUploadPopupLawyer = ({
  file,
  onClose,
  hasLetter,
  onSubmit,
  setFile,
  onRemoveFile
}: DocumentUploadPopupLawyerProps) => {
  const [filename, setFilename] = useState(file ? file.name : '')
  const [error, setError] = useState({
    showFileError: false,
    showFilenameError: false
  })

  const onFileUpload = (newFile: File[]) => {
    setFilename(newFile[0].name || '')

    setFile(newFile)
  }

  const handleSubmit = () => {
    if (!filename || !file) {
      setError({
        showFileError: !file,
        showFilenameError: !filename
      })
      return
    }

    setError({
      showFileError: false,
      showFilenameError: false
    })

    const formData = new FormData()

    formData.append('name', filename)
    formData.append('lawyerdocument', file)

    onSubmit(formData)
  }

  const sendForm = (e) => {
    e.preventDefault()
    handleSubmit()
  }

  return (
    <div className='upload-popup'>
      <div className='upload-form'>
        <form onSubmit={sendForm}>
          <label className='inner-block-title'>Dokumente hochladen</label>

          {file ? (
            <div className='upload-popup__filename'>
              <span>{file.name}</span>
              <button onClick={onRemoveFile} className='upload-delete-button'>
                <DeleteIcon />
              </button>
            </div>
          ) : (
            <div>
              {hasLetter ? (
                <UploadLetterDropzone onUpload={onFileUpload} />
              ) : (
                <UploadDropzone onUpload={onFileUpload} />
              )}
              {error.showFileError && (
                <div className='document-error'>Bitte wähle ein Dokument aus</div>
              )}
            </div>
          )}

          <div className='upload-popup__document-categories'>
            <label>
              <span className='inner-block-title'>Dokumentname eingeben</span>
              <Input
                name='name'
                type='text'
                placeholder='Gib hier einen Namen für dein Dokument ein'
                value={filename}
                onChange={(e) => setFilename(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    handleSubmit()
                  }
                }}
              />
            </label>
          </div>
        </form>

        {error.showFilenameError && (
          <div className='document-error'>Bitte gib einen Dateinamen an</div>
        )}

        <div className='upload-popup__buttons-wrapper'>
          <Button color={Button.colors.primary} onClick={handleSubmit}>
            SPEICHERN
          </Button>
          <Button onClick={onClose}>Abbrechen</Button>
        </div>
      </div>
    </div>
  )
}
